import { render } from "./navElement.vue?vue&type=template&id=47d0556a&scoped=true"
import script from "./navElement.vue?vue&type=script&lang=js"
export * from "./navElement.vue?vue&type=script&lang=js"

import "./navElement.vue?vue&type=style&index=0&id=47d0556a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-47d0556a"

export default script